import React from "react"
import {Swiper, SwiperSlide} from "swiper/react"
import {Autoplay, Mousewheel} from "swiper/modules"
import RyderLivescoringMatchCard from "@/components/RyderLivescoring/RyderLivescoringMatchCard"

const RyderLivescoringSessionDefaultView = ({
    teams,
    session,
    teamIds,
    showHeader,
    headerName,
    hideModality,
    colors,
    useSwiper,
    wrapperStyle,
    wrapperRef,
    slideCount,
    matchCardRef,
    onWheel,
    swiperRef,
    customDesign,
    teamColors
}) => {
    return (
        <section className="mb-6 flex flex-col h-auto sm:h-screen lg:h-screen">
            {showHeader && (
                <div className="w-full max-w-screen-xl mx-auto my-2">
                    <div className="flex items-center justify-center">
                        <div className="flex-1 flex items-center justify-center min-w-0">
                            <div
                                className={`round-point flex flex-col items-center justify-center w-16 h-16 text-base sm:w-16 sm:h-13 sm:text-3xl md:w-24 md:h-20 md:text-5-xl xl:w-32 xl:h-24 team-header-${colors[0]}`}
                            >
                                <h2 className="mt-1 text-base sm:text-lg md:text-3-xl xl:text-5-xl truncate score-round">
                                    {teams[teamIds[0]].score[session.id]}
                                </h2>
                            </div>
                        </div>
                        <div className="flex-1 flex flex-col items-center justify-center px-2 text-center min-w-0">
                            <h3 className="text-base font-bold sm:text-xl md:text-2-xl xl:text-4-xl truncate">
                                {headerName || session.name}
                            </h3>
                            {!hideModality && (
                                <h4 className="modality-name">
                                    {session.modality}
                                </h4>
                            )}
                            <p className="text-xs sm:text-sm md:text-base xl:text-xl text-gray-500 truncate">
                                {session.date}
                            </p>
                        </div>
                        <div className="flex-1 flex items-center justify-center min-w-0">
                            <div
                                className={`round-point flex flex-col items-center justify-center w-16 h-16 text-base sm:w-16 sm:h-13 sm:text-3xl md:w-24 md:h-20 md:text-5-xl xl:w-32 xl:h-24 team-header-${colors[1]}`}
                            >
                                <h2 className="mt-1 text-base sm:text-lg md:text-3-xl xl:text-5-xl font-bold truncate score-round">
                                    {teams[teamIds[1]].score[session.id]}
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {useSwiper ? (
                <div
                    ref={wrapperRef}
                    className="flex-1 relative w-full 2xl:max-w-full px-4 sm:px-3 overflow-hidden"
                    onWheel={onWheel}
                    style={wrapperStyle}
                >
                    <Swiper
                        direction="vertical"
                        slidesPerView={slideCount}
                        spaceBetween={0}
                        loop={false}
                        grabCursor
                        modules={[Autoplay, Mousewheel]}
                        autoplay={{
                            delay: 10000,
                            disableOnInteraction: false,
                        }}
                        speed={3000}
                        style={{height: "100%"}}
                        onBeforeInit={(s) => {
                            swiperRef.current = s
                        }}
                    >
                        {session.matches.map((match, idx) => (
                            <SwiperSlide key={match.id} style={{paddingBottom: "10px"}}>
                                <div ref={idx === 0 ? matchCardRef : null} className="w-full">
                                    <RyderLivescoringMatchCard
                                        className="w-full"
                                        match={match}
                                        teamColors={teamColors}
                                        leftTeamId={teamIds[0]}
                                        rightTeamId={teamIds[1]}
                                        colors={colors}
                                        customDesign={customDesign}
                                    />
                                </div>
                            </SwiperSlide>
                        ))}

                        <SwiperSlide key="ph" style={{paddingBottom: "10px"}}>
                            <div className="w-full opacity-0 pointer-events-none">
                                <RyderLivescoringMatchCard
                                    className="w-full"
                                    match={session.matches[0]}
                                    teamColors={teamColors}
                                    leftTeamId={teamIds[0]}
                                    rightTeamId={teamIds[1]}
                                    colors={colors}
                                    customDesign={customDesign}
                                />
                            </div>
                        </SwiperSlide>

                        {window.innerWidth >= 640 && window.innerWidth < 1024 && (
                            <SwiperSlide key="ph2" style={{paddingBottom: "10px"}}>
                                <div className="w-full opacity-0 pointer-events-none">
                                    <RyderLivescoringMatchCard
                                        className="w-full"
                                        match={session.matches[0]}
                                        teamColors={teamColors}
                                        leftTeamId={teamIds[0]}
                                        rightTeamId={teamIds[1]}
                                        colors={colors}
                                        customDesign={customDesign}
                                    />
                                </div>
                            </SwiperSlide>
                        )}
                    </Swiper>
                </div>
            ) : (
                <div className="flex-1 w-full overflow-auto">
                    <div className="flex flex-col">
                        {session.matches.map((match, idx) => (
                            <div key={match.id} style={{paddingBottom: "10px"}}>
                                <RyderLivescoringMatchCard
                                    className="w-full"
                                    match={match}
                                    teamColors={teamColors}
                                    leftTeamId={teamIds[0]}
                                    rightTeamId={teamIds[1]}
                                    colors={colors}
                                    customDesign={customDesign}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </section>
    )
}

export default RyderLivescoringSessionDefaultView
